import { IResortPathInfo } from 'api/resort/types';
import { Routes } from 'routes';
import { PlanYourTrip } from './Component';
import { OuterPlanYourTripPropsType } from './types';
import { hasWeSkiIntegration, weSkiDestinationId } from './WeSki/resolver';
import {
  getBookFlightsCb, getCarRentalCallback, getKayakDomain,
} from './kayak';

// https://mountainnews.jira.com/browse/OWR-1703?focusedCommentId=82943
const US_RESORTS_MAPPED_TO_WESKI = [493, 448, 25, 482, 314, 129, 191, 456, 77, 197, 368, 802, 36, 425, 146, 1093];

interface IRegionPlanYourTripProps extends OuterPlanYourTripPropsType {
  resort: IResortPathInfo,
  templateName?: string,
  isCondensed?:boolean,
}

const PlanYourTripResortWrapper = ({
  resort, templateName, isCondensed, ...props
}: IRegionPlanYourTripProps) => {
  const redirectLodgingPath = Routes.resortTripPlanningLodging(resort);
  const redirectSkiRentalPath = Routes.resortSkiRentals(resort);
  const { title_short: title } = resort;

  const resortUUID = Number.parseInt(resort.uuid, 10);
  const isUSResortMappedToWeSki = resort.country_code === 'USA' && US_RESORTS_MAPPED_TO_WESKI.includes(resortUUID);

  const bookFlightsCb = !isUSResortMappedToWeSki && (getKayakDomain() && resort.hasFlights) ? getBookFlightsCb(resort) : undefined;
  const carRentalsCb = !isUSResortMappedToWeSki && (getKayakDomain() && resort.hasCarRental) ? getCarRentalCallback(resort) : undefined;
  const lodgingProvider = hasWeSkiIntegration({ resortId: resort.uuid }) ? 'weski' : 'tripadvisor';
  const weDestinationId = lodgingProvider === 'weski' ? weSkiDestinationId({ resortId: resort.uuid }) : null;

  return (
    <PlanYourTrip
      {...props}
      contextKey="resort"
      title={title}
      redirectLodgingPath={redirectLodgingPath}
      redirectSkiRentalPath={redirectSkiRentalPath}
      bookFlightsCb={bookFlightsCb}
      carRentalsCb={carRentalsCb}
      lodgingProvider={lodgingProvider}
      weSkiDestinationId={weDestinationId}
      templateName={templateName}
      isCondensed={isCondensed}
    />
  );
};

export default PlanYourTripResortWrapper;
